import { ReportsFilter } from '../types/ReportsFilter';

export const noSearchParamsProvided = (searchParams: ReportsFilter): boolean =>
  !searchParams.name && !searchParams.endDate;
